import { Avatar, Button, Card, CardContent, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Stack, Typography } from "@mui/material";
import { Fragment, useState } from "react";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ModalXenplatform from "./ModalXenplatform";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const paymentMethod = [
    {id: 1, name: "Mandiri Virtual Account", channel: "MANDIRI", logo: "Mandiri.png", pg: "Xendit"},
    {id: 2, name: "BRI Virtual Account", channel: "BRI", logo: "BRI.png", pg: "Xendit"},
    {id: 3, name: "BNI Virtual Account", channel: "BNI", logo: "BNI.png", pg: "Xendit"},
    {id: 4, name: "BSI Virtual Account", channel: "BSI", logo: "BSI.png", pg: "Xendit"},
    {id: 5, name: "BJB Virtual Account", channel: "BJB", logo: "BJB.png", pg: "Xendit"},
    {id: 6, name: "CIMB Virtual Account", channel: "CIMB", logo: "CIMB.png", pg: "Xendit"},
    {id: 7, name: "Permata Virtual Account", channel: "PERMATA", logo: "Permata.png", pg: "Xendit"},
    {id: 8, name: "BSS Virtual Account", channel: "SAMPOERNA", logo: "BSS.png", pg: "Xendit"},
    {id: 9, name: "QRIS", channel: "QRIS", logo: "QRIS.png", pg: "Xendit"},
    {id: 10, name: "Alfamart / Alfamidi", channel: "ALFAMART", logo: "Alfamart.png", pg: "Xendit"},
    {id: 11, name: "Dana", channel: "DANA", logo: "DANA.png", pg: "Xendit"},
    {id: 12, name: "OVO", channel: "OVO", logo: "OVO.png", pg: "Xendit"},
    {id: 13, name: "ShopeePay", channel: "SHOPEEPAY", logo: "Shopee.png", pg: "Xendit"},
    {id: 14, name: "LinkAja", channel: "LINKAJA", logo: "LinkAja.png", pg: "Xendit"},
    {id: 15, name: "BRILink", channel: "BRILINK", logo: "BRILINK.png", pg: "Xendit"},
    {id: 16, name: "Indomaret", channel: "INDOMARET", logo: "Indomaret.png", pg: "Xendit"},
    {id: 17, name: "Gopay", channel: "GOPAY", logo: "Gopay.png", pg: "Xendit"},
]

const PaymentMethodXenplatform = ({idUser, id, setIsLoad, state, setState}) => {
    const [dialog, setDialog] = useState(false);
    const [method, setMethod] = useState(null);
    const navigate = useNavigate();

    const handleDialog = (val) => {
        setDialog(val)
    }

    const handlePayment = (val) => {
        setMethod(val);
        setDialog(false);
    }

    const getBank = (val) => {
        const bank = paymentMethod.find((el) => el.id === val);
        return bank?.name
    }

    const handlePayNow = () => {
        const bank = paymentMethod.find((el) => el.id === method);
        if(bank.channel === "ALFAMART" ||
            bank.channel === "MANDIRI" ||
            bank.channel === "BNI" ||
            bank.channel === "BSI" ||
            bank.channel === "BJB" ||
            bank.channel === "CIMB" ||
            bank.channel === "PERMATA" ||
            bank.channel === "BRILINK" ||
            bank.channel === "INDOMARET" ||
            bank.channel === "BRI" ) {
            navigate(`/invoice/checkout?user_id=${idUser}&invoice_id=${id}&payment_channel=xenplatform&channel=${bank.channel}`)
        } else {
            setIsLoad(true)
            const bank = paymentMethod.find((el) => el.id === method);
            axios.get(`https://ssr.radboox.com/data/invoice/client-pay-now/${idUser}?id=${id}&payment_channel=${bank.pg.toLowerCase()}&channel=${bank.channel}`)
            .then((res) => {
                const data = res.data.message;
                setMethod(null)
                setIsLoad(false)
                window.open(data.url, "_self");
            }).catch((e) =>{
                setIsLoad(false)
                setState({ ...state, open: true, message: "Failed get URL" });
            })
        }
    }

    return <>
        <ModalXenplatform dialog={dialog} handleDialog={handleDialog} handlePayment={handlePayment} />
        <Card sx={{marginY: 3}}>
            <CardContent>
                <List dense sx={{ width: '100%', bgcolor: 'background.paper' }}>
                    <ListItem
                        secondaryAction={
                            <IconButton edge="end" aria-label="delete" onClick={() => handleDialog(true)}>
                                <KeyboardArrowRightIcon />
                            </IconButton>
                        }
                        disablePadding
                    >
                        <ListItemButton
                            onClick={() => handleDialog(true)}
                        >
                            <ListItemAvatar>
                                <Avatar
                                    variant="square"
                                    alt={`Avatar ada`}
                                    src={process.env.PUBLIC_URL + '/xendit.svg'}
                                />
                            </ListItemAvatar>
                            <ListItemText primary={
                                <Fragment>
                                    <Typography
                                    component="span"
                                    variant="body1"
                                    sx={{ color: 'text.primary', display: 'inline' }}
                                    >
                                        Xendit Indonesia
                                    </Typography>
                                </Fragment>
                            } />
                        </ListItemButton>
                    </ListItem>
                </List>
            </CardContent>
        </Card>
        <Stack direction={"row"} alignItems={"center"} sx={{marginTop: 1, marginBottom: 0.5}}>
            <Typography variant="caption">Payment Method : </Typography>
            {method !== null && (
                <Typography sx={{paddingLeft: 1, fontWeight: 500}}>{getBank(method)}</Typography>
            )}
        </Stack>
        <Button variant="contained" fullWidth disabled={method === null} onClick={() =>handlePayNow()} >Pay Now</Button>
    </>
}

export default PaymentMethodXenplatform;